module.exports = __webpack_public_path__ + "img/qgsyt4.c4f51456.png";